// Create: src/config/index.ts

import CryptoJS from "crypto-js";

const CONFIG = {
  // API URLs
  serverurl: "https://deviceapi.applay.cloud",
  playlistUrl:
    "https://idx-applay-deviceapi-mongodb-20654400-1021674888438.europe-west1.run.app",

  // Auth object
  authobject: {
    username: "", // Will be set dynamically from localStorage
    password: "", // Will be set dynamically from localStorage
    appid: 1001,
    company_id: "", // Will be set if available
    boxid: "", // Device ID / MAC address
    encryption_key: "asdfasdfasdfasdf", // Your encryption key from App.js
  },

  // Post data for API requests
  postdata: {
    devicebrand: "Android TV",
    app_name: "Android TV Playlist",
    appversion: "1.0.0",
    hdmi: true,
    api_version: "1.0",
    language: "EN",
    device_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ntype: 1,
    macaddress: "", // Will be set dynamically
    os: "Android",
    screensize: "1920x1080",
    firmwareversion: "1.0",
    company_id: "",
    player: "exo",
  },

  developer: {
    debug: false,
  },
};

// Initialize CONFIG from localStorage
export function initializeConfig() {
  const username = localStorage.getItem("username") || "";
  const password = localStorage.getItem("password") || "";
  const deviceId =
    localStorage.getItem("device_id") ||
    localStorage.getItem("generated_device_id") ||
    "";
  const userId = localStorage.getItem("user_id") || "";

  CONFIG.authobject.username = username;
  CONFIG.authobject.password = password;
  CONFIG.authobject.boxid = deviceId;
  CONFIG.authobject.company_id = userId;

  CONFIG.postdata.macaddress = deviceId;
  CONFIG.postdata.company_id = userId;

  console.log("📦 CONFIG initialized:", {
    username,
    deviceId,
    userId,
  });

  return CONFIG;
}

export default CONFIG;
